import {
  LOADING_MAIN,
  LOADING_MAIN_DONE,
  ON_SHOW_LOADER,
  ON_SHOW_LOADER_DONE,
  SHOW_MESSAGE,
  SIGNIN_USER_NOT_ACTIVE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_ERROR,
  SIGNUP_USER_SUCCESS,
  USER_TOKEN_SET
} from "appRedux/constants";
import { getSession } from "appRedux/store/cookies";

const INIT_STATE = {
  token: getSession(),
  loader_main: false,
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  // authUser: localStorage.getItem('user'),
  authUser: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true
        //loader: false
      };
    }
    case LOADING_MAIN: {
      return {
        ...state,
        loader_main: true
      };
    }
    case LOADING_MAIN_DONE: {
      return {
        ...state,
        loader_main: false
      };
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      };
    }
    case ON_SHOW_LOADER_DONE: {
      return {
        ...state,
        loader: false
      };
    }
    case SIGNIN_USER_SUCCESS: {
      //localStorage.setItem('user', action.payload)
      return {
        ...state,
        //loader: false,
        authUser: action.payload
      };
    }
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false
      };
    }
    case SIGNUP_ERROR: {
      return {
        ...state,
        loader: false,
        showMessage: false,
        authUser: null
      };
    }
    case SIGNIN_USER_NOT_ACTIVE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
        authUser: null
      };
    }
    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ""
      };
    }

    default:
      return state;
  }
};
